import { LayoutState } from '../../features/layout/types/layout-state.type';

const getDefaultLayout = (): LayoutState => ({
  ilrImage: {
    hasImage: false,
    loaded: false,
  },
  showParentHRPlot: true,
  showHrInBpm: false,
  sortingStrategy: 'Time',
  filterOption: 'All',
  gain: 1,
  display: 'us',
  showDelineation: true,
  lead: 'MLII',
  withDiagnosticGroup: false,
  withSuggestionsPanel: false,
  withComputedMetrics: false,
  withPatientInfo: false,
});

export const getLayoutMock = (layout?: Partial<LayoutState>): LayoutState => ({
  ...getDefaultLayout(),
  ...layout,
});
